import { formatText } from '../lib/utils';
import { motion, AnimatePresence } from 'framer-motion';
import { useState, useEffect } from 'react';
import TiltedCard from './TiltedCard';
import airesha from '../assets/animation/airesha.webp';
import arivo from '../assets/animation/arivo.webp';
import cristalthink from '../assets/animation/cristalthink.webp';
import omega from '../assets/animation/omega.webp';
import sirius from '../assets/animation/sirius.webp';

const images = [airesha, arivo, cristalthink, omega, sirius];

const Hero = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <motion.section
      id="hero"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      style={{
        background: 'linear-gradient(113.97deg, rgba(239, 68, 68, 0) 39.658%, rgba(239, 68, 68, 1) 150.01%), #171717'
      }}
      className="flex flex-col md:pb-[6rem] sm:pb-[4rem] pb-[4rem] lg:pb-[80px] md:pt-[6rem] sm:pt-[4rem] pt-[4rem] lg:pt-[80px] border-solid border-b-[1px] border-t-[0px] border-r-[0px] border-l-[0px] border-opacity-[100%] border-[#525252] xl:w-[100%] w-[100%] ml-[auto] mr-[auto] max-w-[auto]"
    >
      <div className="flex flex-col w-[100%] max-w-[1280px] mr-[auto] ml-[auto] md:pr-[4rem] sm:pr-[4rem] pr-[1.5rem] lg:pr-[32px] md:pl-[4rem] sm:pl-[4rem] pl-[1.5rem] lg:pl-[32px] 2xl:max-w-[1536px]">
        <div className="flex flex-col sm:flex-row gap-[64px] sm:gap-[64px] md:gap-[2rem] items-center">
          <div className="w-[100%] h-[auto] space-y-[2rem] sm:pt-[0rem] pt-[0rem] md:pt-[0rem] sm:pb-[0rem] pb-[0rem] md:pb-[0rem]">
            <motion.span
              initial={{ x: -20, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              transition={{ delay: 0.2 }}
              className="block leading-[1.5em] sm:text-[18px] text-[18px] md:text-[20px] text-opacity-[100%] text-[#a3a3a3]"
            >
              {formatText("Szukasz sposobów na zwiększenie sprzedaży?")}
            </motion.span>
            <motion.h1
              initial={{ x: -20, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              transition={{ delay: 0.3 }}
              className="font-semibold block md:text-[48px] sm:text-[36px] text-[36px] lg:text-[64px] min-[1440px]:text-[72px] tracking-[0px] leading-[1.1em]"
            >
              {formatText("Skalujemy biznesy e-commerce i B2B dzięki skutecznym kampaniom Meta Ads i Google Ads!")}
            </motion.h1>
            <motion.span
              initial={{ x: -20, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              transition={{ delay: 0.4 }}
              className="block sm:text-[18px] text-[18px] md:text-[20px] text-opacity-[100%] text-[#a3a3a3] font-normal transform"
            >
              {formatText("Nie czekaj, aż konkurencja Cię wyprzedzi!")}
            </motion.span>
            <motion.button
              onClick={() => document.getElementById('why-we')?.scrollIntoView({ behavior: 'smooth' })}
              whileHover={{ opacity: 0.9 }}
              whileTap={{ scale: 0.95 }}
              type="button"
              className="flex flex-row items-center justify-center border-[transparent] border-[1px] border-solid sm:hover:border-opacity-[100%] hover:border-opacity-[100%] md:inline-block focus:outline-none rounded-[12px] font-medium text-[16px] tracking-[-0.025em] leading-[1.5em] bg-opacity-[100%] text-opacity-[100%] sm:hover:text-[#ffffff] hover:text-[#ffffff] md:text-[#000000] text-[#000000] sm:hover:bg-[#525252] hover:bg-[#525252] md:bg-[#ffffff] bg-[#ffffff] pt-[12px] pb-[12px] pl-[48px] pr-[48px] w-[100%] sm:w-auto"
            >
              <span className="text-[18px] md:font-medium sm:font-medium font-medium lg:font-medium">Zobacz realizacje</span>
            </motion.button>
          </div>
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            transition={{ delay: 0.4 }}
            className="flex w-[100%] justify-end"
          >
            <TiltedCard
              rotateDepth={17.5}
              translateDepth={20}
              containerClassName="w-[100%] md:w-[75%]"
              className="w-full bg-[#171717] border-[1px] border-[#525252] pt-[1rem] pl-[1rem] pr-[1rem] pb-[1rem] space-y-[1rem] rounded-[6px] shadow-[0_32px_32px_-12px_rgba(0,0,0,0.12)]"
            >
              <div className="relative w-full aspect-square overflow-hidden rounded-[4px]">
                <AnimatePresence>
                  <motion.img
                    key={currentImageIndex}
                    src={images[currentImageIndex]}
                    initial={{ opacity: 1, zIndex: 1 }}
                    animate={{ opacity: 1, zIndex: 1 }}
                    exit={{ opacity: 0, zIndex: 10 }}
                    transition={{ duration: 1.5, ease: "easeInOut" }}
                    className="absolute top-0 left-0 w-full h-full object-cover"
                    alt="Hero Image"
                  />
                </AnimatePresence>
              </div>
              <div className="flex flex-row gap-[12px]">
                <div className="w-[100%] flex justify-between pt-[1.5rem] pb-[1.5rem]">
                  <div className="flex gap-[1rem]">
                    <motion.i whileHover={{ scale: 1.2 }} className="block w-[24px] h-[auto] cursor-pointer">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-heart-icon lucide-heart">
                        <path d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5"></path>
                      </svg>
                    </motion.i>
                    <motion.i whileHover={{ scale: 1.2 }} className="block w-[24px] h-[auto] cursor-pointer">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-message-circle-icon lucide-message-circle">
                        <path d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719"></path>
                      </svg>
                    </motion.i>
                    <motion.i whileHover={{ scale: 1.2 }} className="block w-[24px] h-[auto] cursor-pointer">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-send-icon lucide-send">
                        <path d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z"></path>
                        <path d="m21.854 2.147-10.94 10.939"></path>
                      </svg>
                    </motion.i>
                  </div>
                  <motion.i whileHover={{ scale: 1.2 }} className="block w-[24px] h-auto cursor-pointer">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-bookmark-icon lucide-bookmark">
                      <path d="m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z"></path>
                    </svg>
                  </motion.i>
                </div>
              </div>
            </TiltedCard>
          </motion.div>
        </div>
      </div>
    </motion.section >
  );
};

export default Hero;

